export enum TenantFeatures {
  Qualifications = 'Qualifications',
  DynamicsIntegration = 'DynamicsIntegration',
  ElsmartIntegration = 'Elsmart',
  FlexiSaldo = 'FlexiSaldo',
  TimeAllowNegativeHours = 'TimeAllowNegativeHours',
}

export function hasTenantFeature(
  tenant: { tenantFeatures: string[] } | null,
  feature: TenantFeatures,
): boolean {
  return tenant?.tenantFeatures.includes(feature) || false;
}
